import axios from 'axios'
import { supportApiURL, commonHeadersMPWeb } from './services'
import { getCountryCode } from 'src/consumer/services'
import { getMainLanguageCode } from 'src/consumer/services'
import { platformWeb } from 'src/consumer/services'

/**
 * Get booked sessions for a mentor (support portal API)
 * @param {number} page - Page number (0-indexed)
 * @param {string} listingApiSignature - API endpoint
 * @param {object} passedParams - Additional parameters
 * @returns {Promise} Axios response
 */
export async function getBookedSessionsForMentorSupport(
  page = 0,
  listingApiSignature = '/api/secure/cc/support/events/all/paginated',
  passedParams = {},
) {
  const token = localStorage.getItem('token')
  if (token) {
    try {
      // Build params object, handling arrays properly for query string
      const params = {
        page: passedParams.page !== undefined ? passedParams.page : page,
        size: passedParams.size || passedParams.pageSize || 20,
        ...passedParams,
      }

      // Remove pageSize if size is set
      if (params.size) {
        delete params.pageSize
      }

      const countryCode = getCountryCode()
      const mainLanguageCode = getMainLanguageCode()

      // Handle array parameters - axios will serialize them correctly
      const res = await axios.get(`${supportApiURL}${listingApiSignature}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          ...commonHeadersMPWeb,
          'ef-user-country-code': countryCode,
          'ef-app-language': mainLanguageCode,
        },
        params: {
          languageCode: mainLanguageCode,
          platform: platformWeb,
          countryCode: countryCode,
          ...params,
        },
        paramsSerializer: {
          indexes: null, // Use bracket notation for arrays: eventTypes[]=value1&eventTypes[]=value2
        },
      })
      return res
    } catch (err) {
      console.log(err)
      return err
    }
  }
}

